module.exports = __webpack_public_path__ + "img/微信支付.2066a249.svg";